export const ROLE_SUPERADMIN = 'ROLE_SUPERADMIN'
export const ROLE_ADMIN = 'ROLE_ADMIN'
export const ROLE_USER = 'ROLE_USER'
export const ROLE_FEATURE_MANAGER = 'ROLE_FEATURE_MANAGER'

export default class RoleHelper {
  static get ROLE_SUPERADMIN_LEVEL() {
    return 0b100
  }

  static get ROLE_ADMIN_LEVEL() {
    return 0b010
  }

  static get ROLE_USER_LEVEL() {
    return 0b001
  }

  static getRoleLevel(roleList) {
    if (!Array.isArray(roleList)) {
      throw new Error('Arg `roleList` must be array')
    }

    let level = 0
    // eslint-disable-next-line guard-for-in
    for (const key in roleList) {
      switch (roleList[key]) {
        case ROLE_FEATURE_MANAGER:
          break
        case ROLE_SUPERADMIN:
          level += this.ROLE_SUPERADMIN_LEVEL
          break
        case ROLE_ADMIN:
          level += this.ROLE_ADMIN_LEVEL
          break
        case ROLE_USER:
          level += this.ROLE_USER_LEVEL
          break
        default:
          return null
      }
    }

    return level
  }

  /**
   *
   * @param role Integer
   * @returns {boolean}
   */
  static isSu = role => role >= this.ROLE_SUPERADMIN_LEVEL

  /**
   *
   * @param role Integer
   * @returns {boolean}
   */
  static isAdmin = role => role >= this.ROLE_ADMIN_LEVEL
}
